const cardTypes = [
    {
        id: Math.random(),
        title: 'Animals',
        icons: [
            "fa-cat", "fa-cat",
            "fa-dog", "fa-dog",
            "fa-hippo", "fa-hippo",
            "fa-fish", "fa-fish",
            "fa-horse", "fa-horse",
            "fa-dove", "fa-dove",
            "fa-frog", "fa-frog",
            "fa-crow", "fa-crow"
        ],
        index: 0
    },
    {
        id: Math.random(),
        title: 'Brands',
        icons: [
            "fa-apple", "fa-apple",
            "fa-amazon", "fa-amazon",
            "fa-facebook-f", "fa-facebook-f",
            "fa-behance", "fa-behance",
            "fa-react", "fa-react",
            "fa-js", "fa-js",
            "fa-github", "fa-github",
            "fa-google", "fa-google"
        ],
        index: 1
    },
    {
        id: Math.random(),
        title: 'Buildings',
        icons:     [
            "fa-campground", "fa-campground",
            "fa-church", "fa-church",
            "fa-hospital", "fa-hospital",
            "fa-igloo", "fa-igloo",
            "fa-industry", "fa-industry",
            "fa-monument", "fa-monument",
            "fa-mosque", "fa-mosque",
            "fa-vihara", "fa-vihara"
        ],
        index: 2
    },
    {
        id: Math.random(),
        title: 'Construction',
        icons:     [
            "fa-brush", "fa-brush",
            "fa-drafting-compass", "fa-drafting-compass",
            "fa-hammer", "fa-hammer",
            "fa-hard-hat", "fa-hard-hat",
            "fa-paint-roller", "fa-paint-roller",
            "fa-screwdriver", "fa-screwdriver",
            "fa-wrench", "fa-wrench",
            "fa-ruler", "fa-ruler"
        ],
        index: 3
    },
    {
        id: Math.random(),
        title: 'Currency',
        icons:     [
            "fa-dollar-sign", "fa-dollar-sign",
            "fa-euro-sign", "fa-euro-sign",
            "fa-pound-sign", "fa-pound-sign",
            "fa-yen-sign", "fa-yen-sign",
            "fa-won-sign", "fa-won-sign",
            "fa-rupee-sign", "fa-rupee-sign",
            "fa-tenge", "fa-tenge",
            "fa-ruble-sign", "fa-ruble-sign",
        ],
        index: 4
    },
    {
        id: Math.random(),
        title: 'Emoji',
        icons:     [
            "fa-grin", "fa-grin",
            "fa-angry", "fa-angry",
            "fa-dizzy", "fa-dizzy",
            "fa-flushed", "fa-flushed",
            "fa-grimace", "fa-grimace",
            "fa-grin-beam", "fa-grin-beam",
            "fa-grin-hearts", "fa-grin-hearts",
            "fa-grin-tongue-squint", "fa-grin-tongue-squint"
        ],
        index: 5
    },
    {
        id: Math.random(),
        title: 'Food',
        icons:     [
            "fa-bacon", "fa-bacon",
            "fa-carrot", "fa-carrot",
            "fa-drumstick-bite", "fa-drumstick-bite",
            "fa-egg", "fa-egg",
            "fa-hamburger", "fa-hamburger",
            "fa-hotdog", "fa-hotdog",
            "fa-ice-cream", "fa-ice-cream",
            "fa-pizza-slice", "fa-pizza-slice"
        ],
        index: 6
    },
    {
        id: Math.random(),
        title: 'Maths',
        icons:     [
            "fa-divide", "fa-divide",
            "fa-equals", "fa-equals",
            "fa-infinity", "fa-infinity",
            "fa-minus", "fa-minus",
            "fa-percentage", "fa-percentage",
            "fa-plus", "fa-plus",
            "fa-times", "fa-times",
            "fa-square-root-alt", "fa-square-root-alt"
        ],
        index: 7
    },
    {
        id: Math.random(),
        title: 'Sports',
        icons:     [
            "fa-baseball-ball", "fa-baseball-ball",
            "fa-basketball-ball", "fa-basketball-ball",
            "fa-bowling-ball", "fa-bowling-ball",
            "fa-football-ball", "fa-football-ball",
            "fa-table-tennis", "fa-table-tennis",
            "fa-volleyball-ball", "fa-volleyball-ball",
            "fa-futbol", "fa-futbol",
            "fa-golf-ball", "fa-golf-ball"
        ],
        index: 8
    },
    {
        id: Math.random(),
        title: 'Vehicles',
        icons:     [
            "fa-bus", "fa-bus",
            "fa-car", "fa-car",
            "fa-subway", "fa-subway",
            "fa-ship", "fa-ship",
            "fa-taxi", "fa-taxi",
            "fa-train", "fa-train",
            "fa-wheelchair", "fa-wheelchair",
            "fa-bicycle", "fa-bicycle"
        ],
        index: 9
    },
]

export default cardTypes;